import { endsWith } from 'lodash';

export const getFilePreview = (file: File): string | null =>
  endsWith(file.name, 'pdf') ? null : URL.createObjectURL(file);
